function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useSelector } from 'react-redux';
import { REDUCER_GLOBAL_NAME } from 'moduleBase/constants';
import { useEffect } from 'react';

var SatisMeter = function SatisMeter() {
  var satisMeterData = useSelector(function (state) {
    return state[REDUCER_GLOBAL_NAME].satisMeterData;
  });
  useEffect(function () {
    if (!satisMeterData) {
      return null;
    } // eslint-disable-next-line func-names


    (function () {
      // eslint-disable-next-line func-names
      window.satismeter = window.satismeter || function () {
        // eslint-disable-next-line prefer-rest-params
        (window.satismeter.q = window.satismeter.q || []).push(arguments);
      }; // @ts-ignore


      window.satismeter.l = 1 * new Date();
      var script = document.createElement('script');
      var parent = document.getElementsByTagName('script')[0].parentNode; // @ts-ignore

      script.async = 1;
      script.src = 'https://app.satismeter.com/satismeter.js';
      parent.appendChild(script);
    })();

    var options = _objectSpread({
      writeKey: process.env.SATIS_METER_WRITE_KEY
    }, satisMeterData);

    if ('satismeter' in window) {
      window.satismeter(options);
    }

    return null;
  }, []);
  return null;
};

export { SatisMeter };